import { validateZdl } from "@zapier/zdl-spec";
import isEmpty from "lodash.isempty";
import { snakeCaseKeysDeep } from "@zapier/utils";

const isValidZdl = (zdl: Record<string, any> | undefined): boolean => {
  // Snake case the keys of the ZDL since the ZDL spec expects snake case and we convert it to camel case in the UI
  // https://gitlab.com/zapier/team-engine/zdl-spec/-/blob/master/javascript/zdl-spec/index.js#L95
  const snakeCaseKeysDeepZdl = snakeCaseKeysDeep(zdl);
  if (!isEmpty(zdl)) {
    try {
      // this will return `undefined` if the ZDL is valid
      // or throw an error if it's invalid
      validateZdl(snakeCaseKeysDeepZdl, zdl.zdlVersion);

      return true;
    } catch {
      return false;
    }
  }

  return false;
};

const useIsValidZdl = () => {
  return {
    isValidZdl,
  };
};

export default useIsValidZdl;
